import React from 'react'
import style from '../scss/components/BrandRow.module.scss'

type BrandRowPropTypes = {
    children: any
}

const BrandRow = (props: BrandRowPropTypes) => {
    return (
        <div className={style.Row}>
            {props.children}
        </div>
    )
}

export default BrandRow
